export default {
  methods: {
    groupBy (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x)
        return rv
      }, {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/groupBy.js